export default __webpack_public_path__ + "static/media/section1-process-bg.869df0dc.png";